import { useMutation } from "@apollo/client"
import { CREATE_UNPAID_ORDER } from "../graphql/mutations/createUnpaidOrder"

export const useCreateUnpaidOrderMutation = () => {
  const [createUnpaidOrderMutation, { data, loading, error }] = useMutation(CREATE_UNPAID_ORDER)
  return {
    orderId: data?.id,
    error,
    loading,
    createUnpaidOrderMutation,
  }
}
